export default "__VITE_ASSET__a2bc1304__"